import React from "react";
import {useLocation, useNavigate} from "react-router-dom";

const VideoNav = () => {
    const location = useLocation();
    const navigate = useNavigate();

    const VIDEO_NAV = {
        TAIWANTRADE_VIDEO : {
            tabName: 'taiwantradeVideo',
            path: 'https://info.taiwantrade.com/video/#menu=11610'
        },
        YOUTUBE: {
            tabName: 'youtube',
            path: '/youtube'
        }
    }

    // 根據當前路徑來設定 activeTab
    const getActiveTab = () => {
        if (location.pathname === VIDEO_NAV.TAIWANTRADE_VIDEO.path) return VIDEO_NAV.TAIWANTRADE_VIDEO.tabName;
        if (location.pathname === VIDEO_NAV.YOUTUBE.path) return VIDEO_NAV.YOUTUBE.tabName;
        // no matching go default
        return VIDEO_NAV.NEWS_ALL.tabName;
    };

    const handleTabClick = (tab, path) => {
        if (path.startsWith("http")) {
            window.location.href = path;
        } else {
            navigate(path);
        }
    };

    return (
        <ul className="pageTab nav nav-pills mb-3" id="newsTAB" role="tablist">
            <li className="nav-item" role="presentation">
                <button
                    className={`nav-link ${getActiveTab() === VIDEO_NAV.TAIWANTRADE_VIDEO.tabName ? "active" : ""}`}
                    id="pills-home-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-home"
                    type="button"
                    role="tab"
                    aria-controls="pills-home"
                    aria-selected={getActiveTab() === VIDEO_NAV.TAIWANTRADE_VIDEO.tabName}
                    onClick={() => handleTabClick(VIDEO_NAV.TAIWANTRADE_VIDEO.tabName, VIDEO_NAV.TAIWANTRADE_VIDEO.path)}
                >
                    影音最前線
                </button>
            </li>
            <li className="nav-item" role="presentation">
                <button
                    className={`nav-link ${getActiveTab() === VIDEO_NAV.YOUTUBE.tabName ? "active" : ""}`}
                    id="pills-profile-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-profile"
                    type="button"
                    role="tab"
                    aria-controls="pills-profile"
                    aria-selected={getActiveTab() === VIDEO_NAV.YOUTUBE.tabName}
                    onClick={() => handleTabClick(VIDEO_NAV.YOUTUBE.tabName, VIDEO_NAV.YOUTUBE.path)}
                >
                    Youtube
                </button>
            </li>
        </ul>
    );
};

export default VideoNav;
